import { createApiCall } from 'lib/base';

const FETCH_HOME_WIDGET_DETAIL_API_ID = 'DASHBOARD/FETCH_HOME_WIDGET_DETAIL_API';

const apiCall = createApiCall(FETCH_HOME_WIDGET_DETAIL_API_ID, ({ id }) => ({
  endpoint: `/api/admin/home-widgets/${id}`,
  method: 'GET',
}));

export default apiCall;
